<template>

<div class="vx-card p-6">

  <vx-card card-border class="mb-4" title="Datos identificativos de la empresa" title-color="dark" collapseAction>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span class="campoObligatorio">C.I.F. *</span>
        </div>
        <div>
          <vs-input class="w-full" data-vv-as="CIF" v-validate="'required|alpha_num|checkDNI'" name="cif" v-model="empresa.cif"/>
          <span class="text-danger text-sm"  v-show="errors.has('cif')">{{ errors.first('cif') }}</span>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span class="campoObligatorio">Nombre o razón social *</span>
        </div>
        <div>
          <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombre" v-model="empresa.nombre" 
            @input="v => { empresa.nombre = v.toUpperCase()}"/>
          <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span class="campoObligatorio">Teléfono *</span>
        </div>
        <div>
          <vs-input data-vv-as="TELÉFONO" name="telefono" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" class="w-full" v-model="empresa.telefono" />
          <span class="text-danger text-sm"  v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span class="campoObligatorio">E-mail *</span>
        </div>
        <div>
          <vs-input data-vv-as="EMAIL" name="email" v-validate="'email'" class="w-full" v-model="empresa.email" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
    </div>
  </vx-card>

  <vx-card card-border class="mb-6" title="Datos del responsable" title-color="dark" collapseAction>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div>
          <span class="campoObligatorio">Nombre y apellidos del responsable de la empresa *</span>
        </div>
        <div>
          <vs-input class="w-full" data-vv-as="RESPONSABLE" v-validate="'required'" name="responsable" v-model="empresa.responsable" 
            @input="v => { empresa.responsable = v.toUpperCase()}"/>
          <span class="text-danger text-sm"  v-show="errors.has('responsable')">{{ errors.first('responsable') }}</span>
        </div>
      </div>
    </div>
  </vx-card>

  <vx-card card-border class="mb-6" title="Otros datos de la empresa" title-color="dark" collapseAction>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span>Web</span>
        </div>
        <div>
          <vs-input data-vv-as="WEB" name="web" v-validate="'url'" class="w-full" v-model="empresa.web" />
          <span class="text-danger text-sm"  v-show="errors.has('web')">{{ errors.first('web') }}</span>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div class="vx-col w-full mb-3">
          <span>Empresa inactiva/activa</span>
        </div>
        <div class="vx-col w-full">
          <vs-switch vs-type="success" v-model="empresa.activa"/>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full">
        <div>
          <span>Descripción</span>
        </div>
        <div>
          <vs-textarea name="descripcion" v-model="empresa.descripcion" />
        </div>
      </div>
    </div>
  </vx-card>

  <div class="vx-row">
    <div class="vx-col w-full flex justify-end">
      <vs-button class="mr-4 mb-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
      <vs-button color="warning" type="border" class="mb-2" @click="cancelar()">Cancelar</vs-button>
    </div>
  </div>
</div>

</template>

<script>
// Store Module
import empresasStore from '@/store/configuracion/empresas/index.js'

export default {
  components: {
  },
  data () {
    return {
      empresa: {
        cif: null,
        nombre: null,
        telefono: null,
        email: null,
        responsable: null,
        web: null,
        activa: false,
        mantenimiento: false,
        descripcion: null
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() 
        || this.empresa.cif === undefined || this.empresa.cif === null 
        || this.empresa.nombre === undefined || this.empresa.nombre === null 
        || this.empresa.telefono === undefined || this.empresa.telefono === null 
        || this.empresa.email === undefined || this.empresa.email === null
        || this.empresa.responsable === undefined || this.empresa.responsable === null
      ) {
        return false
      } else {
        return true
      }
    }
  },
  methods:{
    cancelar () {
      this.$router.push({name:'empresas'})
    },
    guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      this.$store.dispatch('empresasStore/addEmpresa', this.empresa)
        .then((response)   => { 
          this.showUpdateSuccess(response.data.nombre)
          this.$router.push({ name: 'empresas' })
        })
        .catch((error) => {
          this.showUpdateError(error)
        })
    },
    showUpdateSuccess (empresa) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'ALTA DE EMRESA',
        text: `La empresa "${ empresa }" ha sido dada de alta correctamente.`
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: `Error al dar de alta la empresa: ${ error }`
      })
    }
  },
  created () {
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }
  }
}
</script>